// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2RfcI","text":"SelectPayment_text__uel_o","title":"SelectPayment_title__1cfQ_","btn":"SelectPayment_btn__2C291"};